import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Sources from "@/pages/Sources";
import SourceDetail from "@/pages/SourceDetail";
import Destinations from "@/pages/Destinations";
import Plans from "@/pages/Plans";
import PlanForm from "@/pages/PlanForm";
import Runs from "@/pages/Runs";
import RunDetail from "@/pages/RunDetail";
import Restore from "@/pages/Restore";
import Settings from "@/pages/Settings";

function Protected() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <span className="font-mono text-sm text-muted-foreground spinner-dots">Loading</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

function LoginGate() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return <Login />;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<LoginGate />} />
      <Route element={<Protected />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/sources" element={<Sources />} />
        <Route path="/sources/:id" element={<SourceDetail />} />
        <Route path="/destinations" element={<Destinations />} />
        <Route path="/plans" element={<Plans />} />
        <Route path="/plans/new" element={<PlanForm />} />
        <Route path="/plans/:id/edit" element={<PlanForm />} />
        <Route path="/runs" element={<Runs />} />
        <Route path="/runs/:id" element={<RunDetail />} />
        <Route path="/restore" element={<Restore />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
